import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import ProjectCard from "../components/projectCard/projectCard"
import './projects.scss'

const ProjectsPage = () => (
  <Layout>
    <SEO title="Projects" />

    <div className="projects__wrapper">
      <ProjectCard
        title="Ξερή (/kʃhɛri/)"
        description="Multiplayer cards game popular among the Greeks"
        url="https://users.iee.ihu.gr/~it174957/ADISE19_me_and_the_boys/"
      />

      <ProjectCard
        title="Smoothies"
        description="Find what smoothies you can make with selected ingredients"
        url="https://github.com/martinkaintas/Smoothies"
      />
      
      <ProjectCard 
        title="The Last Sergeant"
        description="This is another multiplayer game, this time built on Unity, but was never finished."
        url="https://uhmkay.itch.io/the-last-sergeant"
      />
      
      <ProjectCard
        modifier="more"
        title="More to come"
        description="This is not a project but rather a promise that more projects are coming. Follow me on GitHub to stay up to date."
        url="https://github.com/martinkaintas"/>
    </div>
  </Layout>
)

export default ProjectsPage
